<template>
<v-container>
     <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  <v-simple-table class="mt-5">
    <template v-slot:default>
      <thead>
        <tr>
          <th style="width:10px">
          </th>
          <th style="font-size:20px" class="text-left">
            资源类型
          </th>
          <th class="text-left">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="item.Name"
          @click="goTo(item.Identity)"
        >
          <td><v-img height="30px" width="30px" contain :src="item.ImageUri"></v-img></td>
          <td style="font-size:18px"  class="text-left">{{ item.Name }}</td>
          <td class="text-left"></td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name:'resourceType',
    data: ()=>({
        items:[{name:'aaa'},{name:'bbb'}],
        isLoading:false
    }),
    computed: {
      ...mapGetters(["resourceType"])
    },
    async mounted(){
      this.isLoading  = true;
      if (!this.resourceType || this.resourceType.length == 0)
        await this.$store.dispatch('getResourceType');
      this.items  = this.resourceType;
      this.isLoading = false;
    },
    methods:{
       goTo(id)
        {
            this.$router.push('/resourceType/'+id);
        }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/management/ResourceType.vue